// LIBRARIES
import React, { useState } from 'react';
import cx from 'classnames';
import { omit } from 'lodash';
import { isSameMonth } from 'date-fns';
import { Calendar as DefaultCalendar } from 'react-date-range';
// STYLES
import './Calendar.scss';

export const Calendar = ({ ...calendarProps }) => {
  const [shownDate, setShownDate] = useState(calendarProps.showDate ?? (calendarProps.minDate || new Date()));

  return (
    <DefaultCalendar
      showDateDisplay={false}
      weekdayDisplayFormat="EEEEEE"
      shownDate={shownDate}
      onShownDateChange={setShownDate}
      className={cx('customized', calendarProps.className, {
        'first-month': calendarProps.minDate && isSameMonth(shownDate, calendarProps.minDate),
        'last-month': calendarProps.maxDate && isSameMonth(shownDate, calendarProps.maxDate),
      })}
      {...omit(calendarProps, 'className', 'shownDate')}
    />
  );
};
